package com.karyadina.util

import androidx.compose.runtime.Composable
import androidx.compose.runtime.remember
import kotlinx.browser.document
import org.w3c.dom.HTMLInputElement
import org.w3c.files.get

@Composable
actual fun rememberImagePickerLauncher(
    onResult: (List<String>) -> Unit
): ImagePickerLauncher {
    return remember {
        object : ImagePickerLauncher {
            override fun launchPickImage(maxItems: Int) {
                val input = (document.createElement("input") as HTMLInputElement).apply {
                    type = "file"
                    accept = "image/*"
                    multiple = maxItems > 1
                    style.display = "none"
                }

                input.onchange = {
                    val files = input.files
                    if (files != null && files.length > 0) {
                        val count = minOf(files.length, maxItems)
                        val results = arrayOfNulls<String>(count)
                        var processed = 0

                        for (i in 0 until count) {
                            val file = files[i]
                            if (file != null) {
                                val reader = org.w3c.files.FileReader()
                                reader.onload = {
                                    results[i] = reader.result as String
                                    processed++
                                    if (processed == count) {
                                        onResult(results.filterNotNull())
                                    }
                                }
                                reader.readAsDataURL(file)
                            } else {
                                processed++ // Should not happen but safety
                            }
                        }
                    } else {
                        onResult(emptyList())
                    }
                    document.body?.removeChild(input)
                }

                input.oncancel = {
                    onResult(emptyList())
                    document.body?.removeChild(input)
                }

                document.body?.appendChild(input)
                input.click()
            }
        }
    }
}
